import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { LicensePageComponent } from '../pages/cms/license/license-page.component';

@Injectable({
  providedIn: 'root',
})
export class LicenseFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<LicensePageComponent>
{
  canDeactivate(
    component: LicensePageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.licenseForm),
      nextState.url,
      () => component.resetFormChanges(),
      () => component.save()
    );
  }
}
